import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      display: "flex",
      alignItems: "flex-start",
      gap: "baseUnit.mobile2",
      marginTop: "baseUnit.mobile2",
      _first: {
        marginTop: 0,
      },
    }),
  iconCircle: () =>
    css({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: "baseUnit.mobile5",
      height: "baseUnit.mobile5",
      borderRadius: "9999px",
      backgroundColor: "black",
      color: "white",
      overflow: "hidden",
      "& img": {
        width: "20px",
      },
    }),
  text: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile1",
      flex: 1,
      minWidth: 0,
    }),
  title: () =>
    css({
      margin: 0,
      color: "midnight",
      fontWeight: 800,
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
    }),
  description: () =>
    css({
      margin: 0,
      color: "ink",
      fontWeight: 400,
      fontSize: "body.mouse",
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      tabletLandscape: {
        fontSize: "body.cat",
        lineHeight: "body.cat",
        letterSpacing: "body.cat",
      },
    }),
};
